import { Card, Col, message, Modal, Row } from "antd";
import { StyledTable } from "atoms/Table";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { getLocations, getUserInfo } from "redux/selectors";
import styled from "styled-components";
import { EyeOutlined, LoadingOutlined, RightOutlined } from "@ant-design/icons";
import axios from "axios";
import COLORS from "common/Colors";

const Sectiontitle = styled.section`
  font-weight: 500;
  font-size: 16px;
  padding-bottom: 10px;
`;

const StyledSpan = styled.span`
  color: #636980;
  font-size: 14px;
  font-weight: 400;
`;

const StyledModal = styled(Modal)`
  .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
  }
  .item-score {
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
    color: black;
  }
  .item-description {
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
    color: black;
  }
  .modal-title {
    font-weight: 600;
    font-size: 18px;
  }
  .role-title {
    font-weight: 400;
    font-size: 16px;
  }
  .ant-modal-content {
    border-radius: 8px !important;
  }
  .ant-modal-footer {
    border-top: none !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  .cancel-modal-button {
    width: 83px;
    height: 34px;
    border: none;
    font-weight: 400;
    font-size: 16px;
  }
  .discard-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    font-weight: 400;
    font-size: 16px;
  }
  .save-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    font-weight: 400;
    font-size: 16px;
  }
  .modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    margin-bottom: 0;
  }
  .circle-warning-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .tick-created {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .created-text {
    font-weight: 400;
    font-size: 18px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: black !important;
  }
  .ant-tabs-ink-bar {
    background-color: black !important;
  }
  .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: black !important;
  }
`;

const StyledRow = styled(Row)`
  width: 100%;
  display: flex;
  justify-content: center;
  .my-1 {
    display: flex;
    word-wrap: break-word;
  }
  .graybg {
    background-color: #f6f6f6;
  }
  .label_Color {
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3019;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .label_value_Color {
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;
    color: #1f243b;
  }
`;

export const EmployeeInfo = ({
  isModalVisible,
  handleCancelModal,
  selectedEmployee,
}) => {
  const locationList = useSelector(getLocations);
  const userInfo = useSelector(getUserInfo);
  const filterLevelLocationName = locationList?.find(
    (item) => item.location_id === selectedEmployee?.levellocationid
  );

  const viewJobDescription = async (jobdescriptionid, filename) => {
    const token = window.localStorage.getItem("token") || "";
    try {
      const response = await axios.get(
        "https://ozwcklfzkf.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: { jobdescriptionid, filename },
          headers: { Insytsjwt: token },
        }
      );
      if (response?.data?.status === "SUCCESS" && response?.data?.url) {
        window.open(response.data.url, "_blank");
      } else {
        message.error(response?.data?.message || "Failed to fetch document.");
      }
    } catch (error) {
      message.error(error?.message || "Failed to fetch document.");
    }
  };

  const columnsAppraisalInfo = [
    {
      title: "S.No",
      dataIndex: "sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Country",
      dataIndex: "orgLevel",
      render: (text) => text || "-",
    },
    {
      title: "Service Line",
      dataIndex: "areaofwork",
      render: (text) => text || "-",
    },
    {
      title: "Sub Serviceline",
      dataIndex: "subareaofwork",
      render: (text) => text || "-",
    },
    {
      title: "Appraiser",
      dataIndex: "appraisername",
      render: (text, record) => {
        return record.roletype === "Primary"
          ? record.appraiserName || record.appraiser || "-"
          : record.appraisername || record.appraiser || "-";
      },
    },
    {
      title: "Appraisal",
      dataIndex: "appraisal",
      render: (text) => text || "-",
    },
    {
      title: "Weightage(%)",
      dataIndex: "weightage",
      render: (text) => text ?? "-",
    },
    {
      title: "Role Type",
      dataIndex: "roletype",
      render: (text) => text || "-",
    },
    {
      title: "Job Description",
      dataIndex: "jobdescriptionFileName",
      render: (text, record) => {
        if (record.jobdescriptionFileName && record.jobdescriptionFileUrl) {
          return (
            <span
              style={{
                cursor: "pointer",
                color: "#1890ff",
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
              onClick={() =>
                viewJobDescription(
                  record.jobDescriptionId,
                  record.jobdescriptionFileName
                )
              }
            >
              <EyeOutlined style={{ fontSize: 16 }} />
              <span style={{ textDecoration: "underline" }}>View</span>
            </span>
          );
        }
        return "-";
      },
    },
  ];

  const WorkInfoDetails = [
    // {
    //   data: "Overtime Eligible",
    //   value: appraisalDetails?.overtimestatus || "-",
    // },
    // {
    //   data: "Overtime Eligible",
    //   value: appraisalDetails?.overtimestatus || "-",
    // },
    {
      data: "Name of the employee",
      value: selectedEmployee?.fullname || "-",
    },
    //   {
    //     data: "Period",
    //     value: selectedEmployee?.period || "-",
    //   },
    //   {
    //     data: "Start date to attend appraisal",
    //     value: selectedEmployee?.attendstartdate
    //       ? moment(selectedEmployee?.attendstartdate).format("DD-MM-YYYY")
    //       : "-",
    //   },
    //   {
    //     data: "End date to attend appraisal",
    //     value: selectedEmployee?.attendenddate
    //       ? moment(selectedEmployee?.attendenddate).format("DD-MM-YYYY")
    //       : "-",
    //   },
    {
      data: "Employee ID",
      value: selectedEmployee?.employeeid || "-",
    },
    {
      data: "Managing Office",
      value:
        typeof selectedEmployee?.managingoffice === "string"
          ? selectedEmployee?.managingoffice
            ? [selectedEmployee?.managingoffice]
            : "-"
          : selectedEmployee?.managingoffice?.join(", ") || "-",
    },
    {
      data: "Grade",
      value: selectedEmployee?.grade || "-",
    },
    {
      data: "Location",
      value:
        locationList?.find(
          (item) => item.location_id === selectedEmployee?.levellocationid
        )?.location_name || "-",
    },
    {
      data: "Department",
      value: selectedEmployee?.leveldepartmentname || "-",
    },
    {
      data: "Contracting Company",
      value: selectedEmployee?.companyname || "-",
    },
    {
      data: "Designation",
      value: selectedEmployee?.designation || "-",
    },

    {
      data: "Hired Date",
      value: selectedEmployee?.hireddate
        ? moment(selectedEmployee?.hireddate).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Professional Since",
      value: selectedEmployee?.professionalsince
        ? moment(selectedEmployee?.professionalsince).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Target Chargeability %",
      value: selectedEmployee?.targetchargeability || "-",
    },
    {
      data: "Charge Out Rate",
      value: selectedEmployee?.chargeoutrate || "-",
    },
    {
      data: "Last Promotion Date",
      value: selectedEmployee?.lastpromotionlevel
        ? moment(selectedEmployee?.lastpromotionlevel).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Last Promotional Level",
      value: selectedEmployee?.lastpromotion
        ? selectedEmployee?.lastpromotion
        : "-",
    },
  ];

  const personalDet = [
    {
      data: "Salutation",
      value: selectedEmployee?.salutation || "-",
    },

    {
      data: "Date Of Birth",
      value: selectedEmployee?.dateofbirth
        ? moment(selectedEmployee?.dateofbirth).format("DD-MM-YYYY")
        : "-",
    },
    {
      data: "Gender",
      value: selectedEmployee?.gender
        ? selectedEmployee?.gender.charAt(0).toUpperCase() +
          selectedEmployee?.gender.slice(1)
        : "-",
    },
    {
      data: "Marital Status",
      value: selectedEmployee?.maritalstatus
        ? selectedEmployee?.maritalstatus.charAt(0).toUpperCase() +
          selectedEmployee?.maritalstatus.slice(1)
        : "-",
    },
    {
      data: "No. of Dependants",
      value: selectedEmployee?.dependent || "-",
    },
    {
      data: "Greetings",
      value: selectedEmployee?.greetings || "-",
    },

    {
      data: "Phone No",
      value: selectedEmployee?.phoneno || "-",
    },
    {
      data: "Email Address",
      value: selectedEmployee?.userid || "-",
    },
    {
      data: "Postal Address",
      value: selectedEmployee?.postaladdress || "-",
    },

    {
      data: "Emergency Contact Name",
      value: selectedEmployee?.emergencycontactname || "-",
    },
    {
      data: "Emergency Contact Number",
      value: selectedEmployee?.emergencycontactnumber || "-",
    },
  ];
  return (
    <StyledModal
      title={
        selectedEmployee?.userid === userInfo?.userid
          ? "My Info"
          : "Employee Info"
      }
      open={isModalVisible}
      onCancel={handleCancelModal}
      size="lg"
      width={1300}
      bodyStyle={{ height: 550, overflowY: "auto" }}
      style={{
        top: 10,
        maxHeight: "700px",
        overflowY: "auto",
        borderRadius: "10px 10px !important",
      }}
      visible={isModalVisible}
      footer={null}
    >
      <Card
        style={{
          background: "#F3FEFA",
          width: "1237",
          height: "105",
          border: "1px solid rgba(226, 226, 232, 1)",
        }}
        className="card-container"
      >
        <Row gutter={40}>
          <Col xs={2}>
            <div
              style={{
                width: "73px",
                height: "73px",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: " #C2FAE5", // Background for initials
                fontSize: "24px",
                fontWeight: "bold",
                color: "black",
              }}
            >
              {selectedEmployee?.profileurl ? (
                <img
                  src={selectedEmployee?.profileurl}
                  alt="profile-image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <span>
                  {selectedEmployee?.fullname
                    ? selectedEmployee?.fullname.charAt(0).toUpperCase()
                    : "?"}
                </span>
              )}
            </div>
          </Col>
          <Col xs={6}>
            <div>
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: "500",
                  margin: "0",
                }}
              >
                {selectedEmployee?.fullname || "-"} (
                {selectedEmployee?.grade || "-"})
                {/* {findUser?.fullname || "-"} ({findUser?.grade || "-"}) */}
              </p>
              <StyledSpan
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  margin: "0",
                }}
              >
                {selectedEmployee?.designation || "-"}
                {/* {findUser?.designation || "-"} */}
              </StyledSpan>
            </div>
          </Col>
          <Col xs={6}>
            <div className="details1">
              <p>
                Employee ID:{" "}
                <StyledSpan>
                  {selectedEmployee?.employeeid || "-"}
                  {/* {findUser?.employeeid || "-"} */}
                </StyledSpan>{" "}
                <br />
                Managing office:{" "}
                <StyledSpan>
                  {selectedEmployee?.managingoffice || "-"}
                  {/* {findUser?.managingoffice || "-"} */}
                </StyledSpan>{" "}
                <br />
                Location:{" "}
                <StyledSpan>
                  {filterLevelLocationName?.location_name || "-"}
                  {/* {findUser?.country || "-"} */}
                </StyledSpan>
              </p>
            </div>
          </Col>
          <Col xs={6} style={{ paddingLeft: "100px" }}>
            <div className="details2">
              <p>
                Department:{" "}
                <StyledSpan>
                  {selectedEmployee?.leveldepartmentname || "-"}
                  {/* {findUser?.jobtitle || "-"} */}
                </StyledSpan>{" "}
                <br />
                Hired Date:{" "}
                <StyledSpan>
                  {selectedEmployee?.hireddate || "-"}
                  {/* {findUser?.hireddate || "-"} */}
                </StyledSpan>{" "}
                <br />
                Expertise:{" "}
                <StyledSpan>
                  {selectedEmployee?.expertise || "---"}
                  {/* {findUser?.expertise || "---"} */}
                </StyledSpan>
              </p>
            </div>
          </Col>
        </Row>
      </Card>
      <br />
      <div className="mb-2 d-flex justify-content-between align-items-center">
        <p className="employee_detail_headings mb-0">
          <b>Work Information:</b>
        </p>
      </div>
      <Row className="employee_work_info_box">
        {WorkInfoDetails.map((data, index) => {
          return (
            <Col xs={24} lg={12} key={index}>
              <StyledRow className="my-1 employee_work_info">
                <Col
                  sm={24}
                  md={12}
                  className={`my-1 ${
                    data.data === "Office Competency Supervisor" ||
                    data.data === "Regional Competency Supervisor"
                      ? "text-wrap"
                      : "text-nowrap"
                  }`}
                >
                  <b className="label_Color">{data.data}: </b>
                </Col>
                <Col
                  sm={24}
                  md={12}
                  className="my-1 employess_detail_values text-wrap"
                >
                  <b className="label_value_Color">{data.value}</b>
                </Col>
              </StyledRow>
            </Col>
          );
        })}
      </Row>
      <br />
      <div className="mb-2 d-flex justify-content-between align-items-center">
        <p className="employee_detail_headings mb-0">
          <b>Personal Information:</b>
        </p>
      </div>
      <Row className="employee_work_info_box">
        {personalDet.map((data, index) => {
          return (
            <Col xs={24} lg={12} key={index}>
              <StyledRow className="my-1 employee_work_info">
                <Col sm={24} md={12} className="my-1 text-wrap">
                  <b className="label_Color">{data.data}: </b>
                </Col>
                <Col
                  sm={24}
                  md={12}
                  className="my-1 employess_detail_values text-wrap"
                >
                  <b className="label_value_Color">{data.value}</b>
                </Col>
              </StyledRow>
            </Col>
          );
        })}
      </Row>
      <br />
      <div>
        <Sectiontitle>Appraisal Information</Sectiontitle>
      </div>
      <Row>
        <StyledTable
          style={{ width: "100%" }}
          className="mb-3"
          dataSource={selectedEmployee?.appraisalInformation || []}
          columns={columnsAppraisalInfo}
          pagination={false}
          footer={() => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {/* <Button type="dashed" onClick={handleAddRow}>
                                    + Add Another
                                  </Button> */}
            </div>
          )}
          rowKey="key"
        />
      </Row>
    </StyledModal>
  );
};
